<template>
  <div class="tile is-parent is-vertical">
    <p class="formtitle">Cadastrar Novo Simulado</p>

    <article class="tile is-child notification formbox">
      <form @submit.prevent="validate">
        <b-field grouped group-multiline>
          <b-field class="column is-4" label="Data do Simulado">
            <b-datepicker
              v-model="simulado.data"
              icon="calendar-today"
              :date-formatter="formatter"
              name="data"
              v-validate="'required'"
            ></b-datepicker>
          </b-field>
        </b-field>

        <proposta-fields :proposta="simulado" />

        <div class="control has-text-centered">
          <b-button class="button cancelbutton">Cancelar</b-button>
          <button type="submit" class="button updatebutton">{{buttom}}</button>
        </div>
      </form>
    </article>
    <div class="buttons-adicional">
      <b-button class="button addvideoaula" @click="addRow">
        <p>ADICIONAR VIDEOAULA</p>
      </b-button>
    </div>
  </div>
</template>
<script>
import PropostaFields from "@/components/Forms/PropostaFields";

export default {
  name: "simuladoForm",
  props: ["simulado", "buttom"],
  methods: {
    addRow: function() {
      this.simulado.videos.push({
        ordem: "",
        titulo: "",
        video: {
          name: "Escolha um video"
        },
        video_url: null, //quando o video termina de carregar deve ser guardado a url de retorno nessa variavel
        progress: null
      });
    },
    validate() {
      let err = false;
      this.simulado.videos.forEach(el => {
        if (el.progress !== "100.00" || el.video_url === "") {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Existe algum video em upload ou sem arquivo, por favor verifique",
            type: "is-danger",
            hasIcon: true,
            icon: "times-circle",
            iconPack: "fa",
            ariaRole: "alertdialog",
            ariaModal: true
          });
          err = true;
        }
      });
      if (err) return;
      this.$validator.validateAll().then(result => {
        if (result) {
          let self = this;

          this.$emit("formSubmit", self.simulado, () => {});
        }
      });
    },
    formatter(date) {
      return `${date.toLocaleDateString("pt-BR")}`;
    }
  },
  components: {
    PropostaFields: PropostaFields
  }
};
</script>
